import React from 'react';
import { useLocalization } from '../contexts/LocalizationContext';

const About: React.FC = () => {
  const { t } = useLocalization();
  
  return (
    <div className="card">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">{t.about.title}</h2>
      
      <div className="space-y-6">
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.overview.title}</h3>
          <p className="text-gray-600 leading-relaxed">
            {t.about.overview.content}
          </p>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.features.title}</h3>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            {t.about.features.items.map((item, index) => (
              <li key={index}><strong>{item.label}</strong> {item.description}</li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.vatFormats.title}</h3>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-600 mb-2">{t.about.vatFormats.description}</p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
              {t.about.vatFormats.examples.map((example, index) => (
                <div key={index}>• {example}</div>
              ))}
            </div>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.peppolTypes.title}</h3>
          <div className="bg-gray-50 p-4 rounded-lg">
            <ul className="list-disc list-inside space-y-1 text-sm text-gray-600">
              {t.about.peppolTypes.items.map((item, index) => (
                <li key={index}><strong>{item.type}</strong> {item.description}</li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.apiMode.title}</h3>
          <div className="bg-blue-50 border border-blue-200 p-4 rounded-lg">
            <p className="text-sm text-blue-800 mb-2">
              {t.about.apiMode.description}
            </p>
            <ul className="list-disc list-inside space-y-1 text-sm text-blue-800">
              {t.about.apiMode.items.map((item, index) => (
                <li key={index}><strong>{item.mode}</strong> {item.description}</li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.importantNotes.title}</h3>
          <div className="bg-yellow-50 border border-yellow-200 p-4 rounded-lg">
            <ul className="list-disc list-inside space-y-1 text-sm text-yellow-800">
              {t.about.importantNotes.items.map((note, index) => (
                <li key={index}>{note}</li>
              ))}
            </ul>
          </div>
        </div>

        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">{t.about.technicalDetails.title}</h3>
          <div className="bg-blue-50 p-4 rounded-lg">
            <p className="text-sm text-blue-800">
              {t.about.technicalDetails.content}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
